import { useCallback, useState } from 'react';

import {
	UserPreferencesService,
	type UserPreferencesSummary,
} from 'src/services/user-preferences.service';

interface UseUserPreferencesReturn {
	forwardChatWithSummary: UserPreferencesSummary | null;
	loading: boolean;
	error: string | null;
	getSummary: () => Promise<void>;
	updateSummary: (forwardChatWithSummaryValue: boolean) => Promise<void>;
}

export const useUserPreferences = (): UseUserPreferencesReturn => {
	const [forwardChatWithSummary, setFowardChatWithSummary] =
		useState<UserPreferencesSummary | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleError = (error: any) => {
		const errorMessage =
			error?.response?.data?.message || error?.message || 'Erro desconhecido';
		setError(errorMessage);
		console.error('[useUserPreferences] Error:', error);
	};

	const clearError = () => setError(null);

	const getSummary = useCallback(async () => {
		try {
			setLoading(true);
			clearError();
			const result = await UserPreferencesService.getSummary();
			setFowardChatWithSummary(result);
		} catch (error) {
			handleError(error);
		} finally {
			setLoading(false);
		}
	}, []);

	const updateSummary = useCallback(
		async (forwardChatWithSummaryValue: boolean) => {
			try {
				setLoading(true);
				clearError();
				const result = await UserPreferencesService.updateSummary(
					forwardChatWithSummaryValue,
				);
				setFowardChatWithSummary(result);
			} catch (error) {
				handleError(error);
			} finally {
				setLoading(false);
			}
		},
		[],
	);

	return {
		forwardChatWithSummary,
		loading,
		error,
		getSummary,
		updateSummary,
	};
};
